import React from 'react';
import LogoImage from '../assets/youtube.png';

function YoutubeLogo(props: any) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <img alt="youtube-logo" src={LogoImage} {...props} />;
}

export { YoutubeLogo };
